import '../node_modules/bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';

import { createApp } from 'vue';
import axios from 'axios';

import App from './App.vue';
import router from './router/router';
import $bus from './utils/Events';

const app = createApp(App);

// Configurar a URL base do Axios para chamar a api (usa VUE_APP_API_URL do .env)
const apiBase = process.env.VUE_APP_API_URL || 'https://nossaalianca.com/';
axios.defaults.baseURL = apiBase;
// axios.defaults.baseURL = 'http://127.0.0.1:8000';

axios.defaults.withCredentials = true; // Permitir cookies

// Tornar o Axios disponível globalmente
app.config.globalProperties.$axios = axios;

app.use(router);
app.provide('$bus', $bus);
app.mount('#app');